import { Link } from 'react-router';
import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';

import { PRAECE_ROLES, isMobile } from 'constants';
import SVG from 'components/widgets/icons/svg';

class MenuItem extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object,
    roles: PropTypes.array,
    children: PropTypes.node,
    to: PropTypes.any,
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    alert: PropTypes.node,
    add: PropTypes.any,
    link: PropTypes.string,
    internal: PropTypes.bool,
    closeMenu: PropTypes.func,
    trailing: PropTypes.node,
  };

  static defaultProps = {
    roles: PRAECE_ROLES
  }

  constructor() {
    super();

    this.state = { open: false };
    this.open = () => this.setState({ open: true });
    this.close = () => this.setState({ open: false });
    this.toggle = () => this.setState({ open: !this.state.open });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.closed) this.close();
  }

  roleForbidden(roles, currentUser) {
    return !_.find(roles, (role) => role === currentUser.role);
  }

  render() {
    const { open } = this.state;
    const { children, to, icon, label, link, alert, add, internal, roles, currentUser, closeMenu, trailing, ...props } = this.props;
    const passedProps = _.omit(props, 'dispatch');
    const events = isMobile ? { onClick: this.toggle } : {};

    if (this.roleForbidden(roles, currentUser)) return false;

    return (
      <li {..._.omit(passedProps, ['closed'])} onClick={closeMenu || _.noop} className={classNames(passedProps.className, { open })}>
        { to &&
          <Link to={to} tabIndex="-1">
            <SVG src={icon} className="menu-icon" />
            <span>{label}</span>
            {alert}
          </Link>
        }

        { !to && children &&
          <div className="menu-placeholder" {...events}>
            <SVG src={icon} className="menu-icon" />
            <span>{label}</span>
            {alert}
          </div>
        }

        { !to && link &&
          <a href={link} target={internal ? '_self' : '_blank'}>
            <SVG src={icon} className="menu-icon" />
            <span>{label}</span>
            {alert}
          </a>
        }

        { add && _.isString(add) &&
          <Link to={add} className="add-item-link" tabIndex="-1">
            <SVG src="svg/add.svg" />
          </Link>
        }
        { add && !_.isString(add) && add }

        { trailing && <span className="">{trailing}</span> }

        { children && <SVG src="svg/chevron-right.svg" /> }
        { children && <ul className="sub-menu">{children}</ul> }
      </li>
    );
  }
}

// Exports
export default connect((state) => ({
  currentUser: state.auth.currentUser
}))(MenuItem);
